import React, { useEffect } from 'react'
import { ekincare_full_logo} from '../../assets/images'
import {LeftPanel} from '../common/templates/Login';
import BackupCodes from '../common/templates/Login/BackupCodes';
import { useHistory } from 'react-router-dom';
import { useLocation } from 'react-router-dom/cjs/react-router-dom.min';

export default function BackupCodesPage() {
  const location = useLocation()
  const history = useHistory();

  useEffect(() => {
    let mfa_token = sessionStorage.getItem('mfa_token')
    if(!mfa_token) history.push('/login')
  },[])

  let codes = location.state?.backup_codes
  const codesHandler = () => {}

  return (
    <div className='flex min-h-screen'>
        <LeftPanel />
        <div className='w-2/5 pt-16 pl-24 bg-white'>
          <img src={ekincare_full_logo} alt='ekincare_logo' />
        <BackupCodes codesHandler={codesHandler} back_codes={codes} login_button={true} />
      </div> 
    </div>  
  )
}
